export default __webpack_public_path__ + "static/media/taco.0ee3a3a8.svg";